<template>
    <el-dialog :title="(partId === null ? $t('common.create') : $t('common.update')) + ' ' + $t('masters.part')" :visible.sync="showDialog" @open="loadPart" @close="closeDialog" width="620px" :close-on-click-modal="false">
        <el-form v-loading="loading" ref="form" :model="form" :rules="rules" size="small" label-width="240px" label-position="left">
            <el-form-item :label="$t('common.product')" prop="productId">
                <product-selector v-model="form.productId"></product-selector>
            </el-form-item>

            <el-form-item :label="$t('common.number')" prop="no">
                <el-input v-model="form.no"></el-input>
            </el-form-item>

            <el-form-item :label="$t('common.description')" prop="description">
                <el-input type="textarea" v-model="form.description"></el-input>
            </el-form-item>

            <el-form-item :label="$t('common.descriptionFr')" prop="descriptionFr">
                <el-input type="textarea" v-model="form.descriptionFr"></el-input>
            </el-form-item>

            <el-form-item :label="$t('masters.needsReturn')">
                <el-switch v-model="form.needsReturn"></el-switch>
            </el-form-item>

            <el-form-item :label="$t('masters.extDiscountRate')" prop="extendedPriceRate">
                <el-radio-group v-model="form.extendedPriceRate">
                    <el-radio :label="2">50%</el-radio>
                    <el-radio :label="1">35%</el-radio>
                </el-radio-group>
            </el-form-item>

            <el-form-item :label="$t('masters.usListPrice')" prop="usListPrice">
                <el-input v-model.number="form.usListPrice">
                    <template slot="suffix">
                        Extended: {{usExtendedPrice | money}} Non-Warranty: {{usNonWarrantyPrice | money}}
                    </template>
                </el-input>
            </el-form-item>

            <el-form-item :label="$t('masters.cdnListPrice')" prop="cdnListPrice">
                <el-input v-model.number="form.cdnListPrice">
                    <template slot="suffix">
                        {{$t('common.extended')}}: {{cdnExtendedPrice | money}} {{$t('common.nonWarranty')}}: {{cdnNonWarrantyPrice | money}}
                    </template>
                </el-input>
            </el-form-item>

            <el-form-item :label="$t('common.shippingMethod')"
                          prop="shippingMethod">
                <shipping-method-selector v-model="form.shippingMethod"></shipping-method-selector>
            </el-form-item>
            <el-form-item :label="$t('common.otherCompany')"
                          v-if="form.shippingMethod === '5'"
                          prop="otherCompany">
                <el-input v-model="form.otherCompany"></el-input>
            </el-form-item>
            <el-form-item :label="$t('common.coo')" prop="countryOfOrigin">
                <el-input type="textarea" v-model="form.countryOfOrigin"></el-input>
            </el-form-item>
            <el-form-item :label="$t('masters.unavailableForPartsOrders')">
                <el-checkbox class="checkbox"
                             v-model="form.unavailableForPartsOrders" @change="deactivate"></el-checkbox>
            </el-form-item>
            <el-form-item :label="$t('masters.unavailableForClaimsDeactivated')">
                <el-checkbox class="checkbox"
                             v-model="form.unavailableForClaims" @change="deactivate"></el-checkbox>
            </el-form-item>
            <el-form-item :label="$t('masters.authorizationNumRequired')">
                <el-checkbox class="checkbox"
                             v-model="form.isAuthRequired"></el-checkbox>
            </el-form-item>
            <el-form-item :label="$t('masters.pleaseLeaveCommentBeforeDeactivatePart')" v-if="showDeactivateComment">
                <el-input type="textarea"
                          size="small"
                          :rows="4"
                          v-model="form.deactivateComment"
                          :placeholder="$t('common.comment')">
                </el-input>
            </el-form-item>
        </el-form>
        <span slot="footer">
            <el-button :disabled="loading" type="primary" @click="save" v-if="$isFullAdmin">{{partId === null ? $t('common.create') : $t('common.update')}}</el-button>
            <el-button :disabled="loading" @click="closeDialog">{{$t('common.cancel')}}</el-button>
        </span>
    </el-dialog>
</template>

<script>
    import { ProductSelector, ShippingMethodSelector } from '@/app/shared/components'

    import api from '../api'
    export default {
        name: 'create-update-part-dialog',
        props: {
            visible: {
                type: Boolean,
                default: false
            },
            partId: {
                required: false
            }
        },
        components: {
            ProductSelector,
            ShippingMethodSelector
        },
        data() {
            return {
                form: {
                    productId: undefined,
                    no: '',
                    description: '',
                    descriptionFr: '',
                    needsReturn: false,
                    extendedPriceRate: 1,
                    usListPrice: undefined,
                    cdnListPrice: undefined,
                    unavailableForClaims: false,
                    unavailableForPartsOrders: false,
                    isAuthRequired: false,
                    shippingMethod: undefined,
                    countryOfOrigin: ''
                },
                rules: {
                    productId: [
                        {
                            type: 'number',
                            required: true,
                            message: this.$t('common.pleaseSelectProduct'),
                            trigger: 'change'
                        }
                    ],
                    shippingMethod: [
                        {
                            required: true,
                            message: this.$t('shared.pleaseSelectShippingMethod'),
                            trigger: "change"
                        }
                    ],
                    otherCompany: [
                        {
                            validator: (rule, value, callback) => {
                                if (this.form.shippingMethod === "0" && !value) {
                                    // other company
                                    return callback(
                                        new Error(this.$t('common.pleaseEnterShippingCompanyName'))
                                    );
                                } else {
                                    return callback();
                                }
                            },
                            trigger: "blur"
                        }
                    ],
                    no: [
                        {
                            required: true,
                            message: this.$t('common.pleaseEnterPart'),
                            trigger: 'blur'
                        }
                    ],
                    description: [
                        {
                            required: true,
                            message: this.$t('common.pleaseEnterPartDescription'),
                            trigger: 'blur'
                        }
                    ],
                    descriptionFr: [
                        {
                            required: true,
                            message: this.$t('common.pleaseEnterPartDescription'),
                            trigger: 'blur'
                        }
                    ],
                    extendedPriceRate: [
                        {
                            type: 'number',
                            required: true,
                            message: this.$t('common.pleaseSelectPriceRate'),
                            trigger: 'change'
                        }
                    ],
                    usListPrice: [
                        {
                            required: true,
                            message: this.$t('common.pleaseEnterUSListPrice')
                        }
                    ],
                    cdnListPrice: [
                        {
                            required: true,
                            message: this.$t('common.pleaseEnterCDNListPrice')
                        }
                    ]
                },
                loading: false,
                showDialog: this.visible,
                showDeactivateComment: false
            }
        },
        computed: {
            priceMultiplier: function () {
                return this.form.extendedPriceRate === 2 ? 0.5 : 0.65
            },
            usExtendedPrice: function () {
                return this.form.usListPrice * this.priceMultiplier
            },
            usNonWarrantyPrice: function () {
                return this.form.usListPrice * 0.75 // taken from old system
            },
            cdnExtendedPrice: function () {
                return this.form.cdnListPrice * this.priceMultiplier
            },
            cdnNonWarrantyPrice: function () {
                return this.form.cdnListPrice * 0.75 // taken from old system
            }
        },
        watch: {
            visible: function (val) {
                this.showDialog = val
            }
        },
        methods: {
            loadPart() {
                if (this.partId) {
                    this.loading = true
                    api.getPart(this.partId).then(response => {
                        this.loading = false
                        this.form.no = response.data.no;
                        this.form.productId = response.data.productId;
                        this.form.description = response.data.description;
                        this.form.descriptionFr = response.data.descriptionFr;
                        this.form.needsReturn = response.data.needsReturn;
                        this.form.extendedPriceRate = response.data.extendedPriceRate;
                        this.form.usListPrice = response.data.usPrice.listPrice;
                        this.form.cdnListPrice = response.data.cdnPrice.listPrice;
                        this.form.unavailableForPartsOrders = response.data.unavailableForPartsOrders;
                        this.form.unavailableForClaims = response.data.unavailableForClaims;
                        this.form.deactivateComment = response.data.deactivateComment;
                        this.showDeactivateComment = this.form.unavailableForClaims || this.form.unavailableForPartsOrders;
                        this.form.isAuthRequired = response.data.isAuthRequired;
                        this.form.shippingMethod = response.data.shippingMethod;
                        this.form.countryOfOrigin = response.data.countryOfOrigin;
                    })
                }
            },
            closeDialog() {
                this.$refs['form'].resetFields();
                this.showDialog = false;
                this.loading = false;
                this.$emit('dialogClosed');
            },
            save() {
                this.$refs['form'].validate(valid => {
                    if (valid) {
                        this.loading = true
                        this.form.shippingMethod = this.form.shippingMethod == '5' ? 'Other Company' :
                            this.form.shippingMethod == '0' ? 'Express' :
                                this.form.shippingMethod == '1' ? 'Express SAT' :
                                    this.form.shippingMethod == '4' ? 'Standard' : 'Not selected';
                        api.savePart(this.partId, this.form).then((response) => {
                            this.$emit('save', {
                                new: this.partId === undefined,
                                id: this.partId,
                                data: this.form
                            })
                            this.closeDialog()
                        })
                    } else {
                        return false
                    }
                })
            },
            deactivate() {
                this.showDeactivateComment = this.form.unavailableForClaims || this.form.unavailableForPartsOrders;
            }
        }
    }
</script>



// WEBPACK FOOTER //
// ClientApp/app/masters/parts/components/CreateUpdatePartDialog.vue